<template>
  <div class="bg-black w-full">
    <div class="md:p-8 max-md:p-5">
      <div class="md:flex justify-between align-middle items-center">
        <div data-aos="fade-right" delay="0" class="flex font-subtitle text-2xl text-white">Sustain Nova Tech</div>
        <div data-aos="zoom-in" delay="600" class="md:w-3/5 max-md:pt-1 text-gray-400 font-subtitle text-base">
          Forging a Future of Sustainability and Innovation through design thinking. From pioneering breakthroughs in healthcare, agriculture, and impactful social projects to shaping visionary business strategies, we turn dreams into reality.
        </div>
      </div>
      <div class="flex justify-between align-middle items-center pt-3" v-if="!isMobileView">
        <div class="flex justify-start">
          <img
            data-aos="flip-right"
            delay="300"
            :src="icon"
            class="pr-3 cursor-pointer"
            :style="{ width: '10%' }"
            v-for="(icon, index) in icons"
            :key="index"
            @click="handleIconClick(index)"
          />
        </div>
        <!-- <div class="flex flex-col"> -->
        <div class="text-white font-content text-base w-[800px]"><span class="text-lg pr-2">✉</span>    info.sustainnovatechlabs@gmail.com</div>
        <!-- <div class="text-white font-content text-base w-[800px]">+91 9488518552</div> -->
      <!-- </div> -->

      </div>
  
   
        <div  class=" text-base font-content flex flex-row text-white  items-start justify-start pt-3" v-if="!isMobileView">	&#128241 +91 9488518552</div>
  
      
      <div class="md:flex justify-between align-middle items-center pt-5" v-if="isMobileView">
        <div class="icons flex justify-center">
          <img
            data-aos="flip-right"
            delay="300"
            :src="icon"
            class="pr-2 cursor-pointer"
            :style="{ width: '14%' }"
            v-for="(icon, index) in icons"
            :key="index"
            @click="handleIconClick(index)"
          />
        </div>
        <div data-aos="fade-up" class="md:w-3/5 text-xs font-content text-white text-center pt-5">
          <span class="text-lg ">✉</span> info.sustainnovatechlabs@gmail.com
        </div>
        <div class="flex flex-row items-center justify-center align-middle pt-2">
        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="15" viewBox="0,0,256,256">
<g fill="#030303" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,256v-256h256v256z" id="bgRectangle"></path></g><g fill="#ffffff" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(5.12,5.12)"><path d="M14,3.99023c-5.51133,0 -10,4.48867 -10,10v22c0,5.51133 4.48867,10 10,10h22c5.51133,0 10,-4.48867 10,-10v-22c0,-5.51133 -4.48867,-10 -10,-10zM14,5.99023h22c4.43067,0 8,3.56933 8,8v22c0,4.43067 -3.56933,8 -8,8h-22c-4.43067,0 -8,-3.56933 -8,-8v-22c0,-4.43067 3.56933,-8 8,-8zM18.04883,11.03516c-2.04532,-0.08838 -3.5977,0.68877 -4.57422,1.62305c-0.48826,0.46714 -0.84078,0.96698 -1.08203,1.43359c-0.24125,0.46662 -0.39453,0.85131 -0.39453,1.35156c0,-0.04456 -0.01099,0.18933 -0.01758,0.46094c-0.0066,0.27161 -0.0054,0.63775 0.01953,1.08008c0.04996,0.88466 0.1999,2.0813 0.59766,3.5c0.79552,2.8374 2.58679,6.55945 6.47266,10.44531c3.88587,3.88587 7.6077,5.67689 10.44531,6.47266c1.4188,0.39788 2.61526,0.54759 3.5,0.59766c0.44237,0.02503 0.80648,0.02609 1.07813,0.01953c0.27164,-0.0066 0.5073,-0.01758 0.46289,-0.01758c0.50025,0 0.88494,-0.15328 1.35156,-0.39453c0.46662,-0.24125 0.96645,-0.59377 1.43359,-1.08203c0.93428,-0.97652 1.71142,-2.52889 1.62305,-4.57422c-0.04194,-0.97548 -0.58353,-1.83931 -1.38281,-2.35156c-0.61768,-0.39579 -1.57657,-1.01019 -2.82812,-1.81055c-1.45209,-0.92776 -3.3094,-0.99403 -4.82422,-0.16406l0.08594,-0.04297l-1.17773,0.50586l-0.08594,0.06055c-0.28626,0.20099 -0.6408,0.23823 -0.96289,0.10352c-0.90225,-0.3773 -2.30808,-1.11862 -3.61523,-2.42578c-1.30716,-1.30716 -2.04848,-2.71299 -2.42578,-3.61523c-0.13471,-0.32209 -0.09748,-0.67663 0.10352,-0.96289l0.06055,-0.08594l0.50586,-1.17773l-0.04297,0.08594c0.82976,-1.51444 0.76525,-3.37169 -0.16406,-4.82422c-0.80035,-1.25155 -1.41475,-2.21044 -1.81055,-2.82812c-0.51225,-0.79928 -1.37608,-1.34087 -2.35156,-1.38281zM17.96289,13.0332c0.28052,0.01206 0.57015,0.17617 0.75391,0.46289c0.3962,0.61832 1.0109,1.57768 1.81055,2.82813c0.53069,0.82948 0.56799,1.9196 0.09375,2.78516l-0.02344,0.04297l-0.48242,1.12695l0.09961,-0.18164c-0.59101,0.84174 -0.70979,1.93486 -0.3125,2.88477c0.4507,1.07775 1.31258,2.71297 2.85742,4.25781c1.54484,1.54484 3.18006,2.40673 4.25781,2.85742c0.94991,0.39729 2.04303,0.27851 2.88477,-0.3125l-0.18164,0.09961l1.12695,-0.48242l0.04297,-0.02344c0.86518,-0.47403 1.95525,-0.43453 2.78516,0.0957v-0.00195c1.25045,0.79965 2.20981,1.41434 2.82813,1.81055c0.28672,0.18375 0.45083,0.47339 0.46289,0.75391c0.06562,1.51868 -0.46184,2.46949 -1.07031,3.10547c-0.30423,0.31799 -0.63415,0.54877 -0.90625,0.68945c-0.2721,0.14068 -0.53234,0.16992 -0.43359,0.16992c-0.18341,0 -0.28001,0.01203 -0.50977,0.01758c-0.22976,0.0056 -0.53773,0.0059 -0.91797,-0.01562c-0.76047,-0.04303 -1.81015,-0.17285 -3.07422,-0.52734c-2.52814,-0.70898 -5.91718,-2.3078 -9.57031,-5.96094c-3.65313,-3.65313 -5.25221,-7.04246 -5.96094,-9.57031c-0.35437,-1.26393 -0.4844,-2.31385 -0.52734,-3.07422c-0.02147,-0.38019 -0.02119,-0.68823 -0.01562,-0.91797c0.0056,-0.22973 0.01758,-0.32621 0.01758,-0.50977c0,0.09875 0.02924,-0.16149 0.16992,-0.43359c0.14068,-0.2721 0.37146,-0.60202 0.68945,-0.90625c0.63598,-0.60847 1.58679,-1.13594 3.10547,-1.07031z"></path></g></g>
</svg>
        <div  class="md:w-3/5 text-xs font-content text-white text-center pl-1">  +91 9488518552</div>
      </div>
      </div>
    </div>
    <div class="border bg-white"></div>
    <div class="flex justify-between md:px-10 mt-3 p-2 pb-5 font-cont">
      <div class="md:w-1/3 w-10/12 text-white max-md:text-xs">Copyright © 2024 Sustain Nova Tech</div>
      <button
        @click="scrollTo('home')"
        type="button"
        class="md:py-2 md:px-4 p-1 inline-flex justify-center items-center gap-1 rounded-md border border-transparent bg-btnColor text-white max-md:w-1/3 max-md:h-1/6 font-cont text-xs"
      >
        Back to top ↑
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isMobileView: false,
    };
  },
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
    programs: {
      type: Array,
      default: () => [],
    },
    icons: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    if (window.innerWidth < 768) {
      this.isMobileView = true;
    }
    window.addEventListener("resize", () => {
      if (window.innerWidth < 1166) {
        this.isMobileView = true;
      } else {
        this.isMobileView = false;
      }
    });
  },
  methods: {
    scrollTo(sectionId) {
      const section = document.getElementById(sectionId);
      if (section) {
        window.scrollTo({
          top: section.offsetTop - 70,
          behavior: 'smooth',
          duration: 1000,
        });
      }
    },
    handleIconClick(index) {
      switch (index) {
        case 0:
        window.open('https://www.linkedin.com/showcase/sustain-nova-tech-labs-page/about/');
          break;
        case 1:
        window.open('https://www.facebook.com/sustain.nova.tech.labs?sfnsn=wiwspmo&mibextid=RUbZ1f');
          break;
          case 2:
        window.open('https://www.instagram.com/sustain_nova_tech_labs?igsh=cDg3Zmc0aHJhcGhx');
          break;
          case 3:
        window.open('https://x.com/SustainNovaTL?t=Lk8ANIMT_MIlqoyL9k90OQ&s=08');
          break;
          case 4:
        window.open('https://wa.me/919488518552');
          break;
          

        default:
    
          console.log('Unknown icon clicked');
      }
    },
  },
};
</script>